import { useMutation } from "@apollo/react-hooks";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ADD_REVIEW_TO_LATEST_SUBMISSION_EVENT } from "utils";
import {
  ERROR_STATUS,
  SUBMITTED_WITH_LOW_BALANCES,
  UNDERWRITING_RESULT
} from "utils/constants";

const ApplicationSubmissionDatesInfo = ({ events, userId }) => {
  const [addManualReview, { loading: addingManualReview }] = useMutation(
    ADD_REVIEW_TO_LATEST_SUBMISSION_EVENT
  );
  const [
    earliestUserSubmissionDate,
    setEarliestUserSubmissionDate
  ] = useState();
  const [latestUserSubmissionDate, setLatestUserSubmissionDate] = useState();
  const [
    latestSubmissionEventReviewDate,
    setLatestSubmissionEventReviewDate
  ] = useState();

  // assume these are already sorted by latest when passed in as prop
  const submissionEvents = events.filter(event =>
    [UNDERWRITING_RESULT, SUBMITTED_WITH_LOW_BALANCES].includes(event.name)
  );
  const userSubmissionEvents = submissionEvents.filter(
    event => event.metadata.initiated_by === "user"
  );

  const [shouldRender, setShouldRender] = useState(
    userSubmissionEvents.length > 0
  );

  useEffect(() => {
    if (!userSubmissionEvents.length) return;

    const earliestUserSubmissionEvent =
      userSubmissionEvents[userSubmissionEvents.length - 1];
    setEarliestUserSubmissionDate(
      earliestUserSubmissionEvent.created_at.toLocaleDateString()
    );
    const latestUserSubmissionEvent = userSubmissionEvents[0];

    setLatestUserSubmissionDate(
      latestUserSubmissionEvent.created_at.toLocaleDateString()
    );
  });

  useEffect(() => {
    if (!userSubmissionEvents.length) return;

    const latestSubmissionEvent = submissionEvents[0];
    const latestSubmissionEventReviews =
      latestSubmissionEvent.metadata?.reviews || [];

    const sortedLatestSubmissionEventReviews = latestSubmissionEventReviews.sort(
      (event1, event2) => {
        if (event1.reviewed_at === event2.reviewed_at) return 0;
        return event1.reviewed_at < event2.reviewed_at ? 1 : -1;
      }
    );

    const latestSubmissionEventReview = sortedLatestSubmissionEventReviews[0];
    setLatestSubmissionEventReviewDate(
      latestSubmissionEventReview
        ? moment(latestSubmissionEventReview.reviewed_at).format("l")
        : latestUserSubmissionDate
    );
  }, [latestUserSubmissionDate]);

  const handleUpdateReviewClick = async () => {
    try {
      const res = await addManualReview({
        variables: {
          user_id: parseInt(userId)
        }
      });

      const {
        data: {
          addReviewToLatestApplicationSubmissionEvent: { status, message }
        }
      } = res;

      if (status === ERROR_STATUS) {
        setLatestSubmissionEventReviewDate(`Please try again. ${message}`);
        return;
      }
      // could refetch, but could also just assume that if successful,
      // then we can show today's date
      setLatestSubmissionEventReviewDate(moment().format("l"));
    } catch (e) {
      setLatestSubmissionEventReviewDate(`Please try again. ${e.message || e}`);
    }
  };

  return (
    <>
      {shouldRender && (
        <div className="w-full border-t-2 text-sm">
          <table className="tomo-table">
            <tbody>
              <tr>
                <td>Submission date:</td>
                <td>{earliestUserSubmissionDate}</td>
              </tr>
              <tr>
                <td>Most recent submission:</td>
                <td>{latestUserSubmissionDate}</td>
              </tr>
              <tr>
                <td>Last reviewed:</td>
                <td>{latestSubmissionEventReviewDate}</td>
              </tr>
            </tbody>
          </table>

          <div className="text-center">
            <button
              type="button"
              className="btn btn-green py-1 m-2"
              onClick={() => handleUpdateReviewClick()}
              disabled={addingManualReview}
            >
              Update Review
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ApplicationSubmissionDatesInfo;
